import React, { useState, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import "../css/stickers.css";
import tabIconSticker from "../images/tabIconSticker.png";
import { removeAnimations, animateSelectedTool } from "../js/handlers";
import left_arrow from "../images/sticker_arrow.png";
import { default_stickers } from "../js/defaultStickers";

export default function StickersButton() {
  // when click outside "button sticker", "sticker menu" and "sticker menu close", then close sticker menu;
  useEffect(() => {
    let stickersButton = document.querySelector(".stickersButton");
    let stickersContainer = document.querySelector(".stickersContainer");
    let closeStickers = document.querySelector(".stickersClose");

    function mouseDownOutsideMenu(ev) {
      let clickedElement = ev.target;
      let stickerButtonImage = document.querySelector(".tabIconSticker");

      // click outside stickers menu and button, close sticker menu;
      if (
        !stickersContainer.contains(clickedElement) &&
        !stickersButton.contains(clickedElement)
      ) {
        stickersContainer.classList.remove("showTabMenu");
        animateSelectedTool();
      }

      // click on sticker image or close button, close sticker menu;
      if (
        clickedElement.classList.contains("sticker") ||
        closeStickers === clickedElement
      ) {
        stickersContainer.classList.remove("showTabMenu");
      }

      // click sticker button, remove tools animation;
      if (stickerButtonImage === clickedElement) {
        removeAnimations();
      }
    }

    document.addEventListener("click", mouseDownOutsideMenu);

    return () => {
      document.removeEventListener("click", mouseDownOutsideMenu);
    };
  }, []);

  // show sticker menu when sticker button is clicked;
  const showStickersHandler = () => {
    let stickersContainer = document.querySelector(".stickersContainer");

    stickersContainer.classList.add("showTabMenu");
  };

  return (
    <div className="stickersButton" onClick={showStickersHandler}>
      <button>
        <img className="tabIconSticker" src={tabIconSticker} alt="" />
      </button>
      <StickersMenu />
    </div>
  );
}

function StickersMenu() {
  const [stickers, setStickers] = useState([]);
  const [tabs, setTabs] = useState([]);

  // this is to get tabs and stickers for the stickers menu;
  useEffect(() => {
    axios({
      method: "GET",
      url: "/wp-json/artpad/v1/data",
    })
      .then((response) => {
        let stickers = response.data.Channels;
        let channels = stickers.length;
        let allStickers = [];
        let tabsSticker = [];

        for (let i = 0; i < channels; i++) {
          let channel = stickers[i].Stickers;
          let channelLength = channel.length;

          for (let sticker of channel) {
            let stickers = sticker.stickers;
            allStickers.push([...stickers]);
          }

          for (let k = 0; k < channelLength; k++) {
            tabsSticker.push(
              <div
                className={
                  k === 0
                    ? "stickersButtonContainer borderBottom"
                    : "stickersButtonContainer"
                }
                key={uuidv4()}
              >
                <div className="stickersButtonBorder">
                  <button className="stickersButtonWrapper">
                    <img
                      className="stickersButtonImage"
                      src={channel[k].small}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            );
          }
        }

        let stickersLength = allStickers.length;
        let tabs = [];

        for (let a = 0; a < stickersLength; a++) {
          let counter = 0;
          let rows = [];
          let stickersLvl0 = allStickers[a];
          let stickersPerRow = 7;
          let rowsNumber = Math.ceil(stickersLvl0.length / 7);

          for (let b = 0; b < rowsNumber; b++) {
            let row = [];

            for (let c = 0; c < stickersPerRow; c++) {
              if (stickersLvl0[counter]) {
                row.push(
                  <button className="stickerButton" key={uuidv4()}>
                    <img
                      className="sticker"
                      src={stickersLvl0[counter].big}
                      alt=""
                    />
                  </button>
                );
                counter++;
              }
            }

            rows.push(
              <div className="row" key={uuidv4()}>
                {[...row]}
              </div>
            );
          }

          tabs.push(rows);
        }

        setTabs(tabsSticker.slice(0, 10));
        setStickers(tabs);
      })
      .catch(() => {
        let tabsSticker = [];
        let tabs = [];

        tabsSticker[0] = (
          <div
            className={"stickersButtonContainer borderBottom"}
            key={uuidv4()}
          >
            <div className="stickersButtonBorder">
              <button className="stickersButtonWrapper">
                <img
                  className="stickersButtonImage"
                  src={default_stickers[0]}
                  alt=""
                />
              </button>
            </div>
          </div>
        );

        let length = default_stickers.length;

        for (let a = 0; a < length; a++) {
          let counter = 0;
          let rows = [];
          let stickersPerRow = 7;
          let rowsNumber = Math.ceil(default_stickers.length / 7);

          for (let b = 0; b < rowsNumber; b++) {
            let row = [];

            for (let c = 0; c < stickersPerRow; c++) {
              if (default_stickers[counter]) {
                row.push(
                  <button className="stickerButton" key={uuidv4()}>
                    <img
                      className="sticker"
                      crossOrigin="anonymous"
                      src={default_stickers[counter]}
                      alt=""
                    />
                  </button>
                );
                counter++;
              }
            }

            rows.push(
              <div className="row" key={uuidv4()}>
                {[...row]}
              </div>
            );
          }

          tabs.push(rows);
        }

        setTabs(tabsSticker);
        setStickers(tabs);
      });
  }, []);

  // this is for changing tabs in stickers;
  const [currentTab, setCurrentTab] = useState(0);

  useEffect(() => {
    let categories = document.querySelector(".stickersCategories");
    let tabs = categories.querySelectorAll(".stickersButtonContainer");

    function selectTab(ev) {
      if (this !== ev.target && this.contains(ev.target)) {
        let tab = ev.target.closest("div").parentNode;

        setCurrentTab(Array.prototype.indexOf.call(tabs, tab));

        for (let tab of tabs) {
          tab.classList.remove("borderBottom");
        }

        tab.classList.add("borderBottom");
      }
    }

    categories.addEventListener("click", selectTab);

    return () => {
      categories.removeEventListener("click", selectTab);
    };
  });

  const closeHandler = () => {
    animateSelectedTool();
  };

  return (
    <div className="stickersContainer">
      <img className="left_arrow" src={left_arrow} alt="" />
      <div className="stickersCategories">{[...tabs]}</div>
      <div className="stickersBorder">
        <div className="stickers">
          {stickers[currentTab]}
          <button className="stickersClose" onClick={closeHandler}></button>
        </div>
      </div>
    </div>
  );
}
